import React, { useEffect, useMemo, useState } from 'react';
import { cn } from '@bem-react/classname';

import { calculateColumnCount } from '@pages/Gallery/Gallery.utils';

import { IWorkItem } from '@models/works';
import { useParams, useSearchParams } from 'react-router-dom';

import './Gallery.style.scss';
import { gallery_data } from '@config/gallery-list-config';
import { GalleryIDEnum } from '@models/gallery-list';
import { IGalleryProps } from './Gallery.types';
import { Header } from '@components/Header';
import { WorkItemCard } from '@components/WorkItemCard';
import { WorkItemCardModal } from '@components/WorkItemCardModal';
const CnGallery = cn('gallery');

const Gallery = (props: IGalleryProps) => {
  const { id } = props;
  const { galleryId } = useParams() as { galleryId: GalleryIDEnum };
  const listId = id ?? galleryId;
  const workList = useMemo(() => (listId ? gallery_data[listId] : []), [listId]);
  const [list, setList] = useState(calculateColumnCount(window.innerWidth, workList));
  const [activeItem, setActiveItem] = useState<IWorkItem | undefined>(undefined);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSmall, setIsSmall] = useState(window.innerWidth < 700);
  const workId = searchParams.get('id');

  const removeQueryId = () => {
    searchParams.delete('id');
    setSearchParams(searchParams);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
    setList(calculateColumnCount(window.innerWidth, workList));
    const resize = (data: UIEvent) => {
      // @ts-ignore
      setIsSmall(data.target.innerWidth < 700);
      // @ts-ignore
      setList(calculateColumnCount(data.target.innerWidth, workList));
    };

    window.addEventListener('resize', resize);

    return () => window.removeEventListener('resize', resize);
  }, [workList]);

  useEffect(() => {
    if (workId) {
      const item = workList?.find((item) => item.id === workId);
      setActiveItem(item);
    } else {
      setActiveItem(undefined);
    }
  }, [workId, workList]);

  return (
    <>
      <div className={CnGallery()}>
        <Header />
        <div className={CnGallery('content', { isSmall })}>
          {list.map((row, index) => (
            <div key={`row ${index}`} className={CnGallery('content-row', { isSmall })}>
              {row.map((item) => (
                <WorkItemCard
                  key={item.id}
                  isSmall={isSmall}
                  {...item}
                  onItemClick={(id) => setSearchParams({ id })}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
      <WorkItemCardModal item={activeItem} onCancel={removeQueryId} />
    </>
  );
};

export default Gallery;
